export default __webpack_public_path__ + "static/media/D3-1.0a3c3c9a.png";